"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_class_component_1 = __importDefault(require("vue-class-component"));
var vue_property_decorator_1 = require("vue-property-decorator");
var PasswordInput_vue_1 = __importDefault(require("../form/PasswordInput.vue"));
var VButton_vue_1 = __importDefault(require("../scraps/VButton.vue"));
var request_1 = __importDefault(require("../../request"));
var __ = window.$lang;
var AccountSettings = /** @class */ (function (_super) {
    __extends(AccountSettings, _super);
    function AccountSettings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "account-settings";
        _this.currentPassword = "";
        _this.newPassword = "";
        _this.newPasswordConfirmation = "";
        return _this;
    }
    AccountSettings.prototype.afterUpdate = function () {
        this.$notification("success", __("Hasło zostało zaktualizowane."));
    };
    AccountSettings.prototype.isFormValid = function () {
        return (this.currentPassword !== "" &&
            this.newPassword !== "" &&
            this.newPasswordConfirmation === this.newPassword);
    };
    AccountSettings.prototype.submitForm = function () {
        if (!this.isFormValid()) {
            return;
        }
        request_1.default.user.changePassword({
            current_password: this.currentPassword,
            new_password: this.newPassword,
            new_password_confirmation: this.newPasswordConfirmation
        }, this.afterUpdate);
    };
    AccountSettings.prototype.onKeyDown = function (keyCode) {
        if (keyCode === 13) {
            this.submitForm();
        }
    };
    AccountSettings = __decorate([
        vue_class_component_1.default({ components: {
                PasswordInput: PasswordInput_vue_1.default,
                VButton: VButton_vue_1.default
            } })
    ], AccountSettings);
    return AccountSettings;
}(vue_property_decorator_1.Vue));
exports.default = AccountSettings;
